module.exports = __webpack_public_path__ + "img/AdminActionGoals.96d5fe81.png";